import { cva } from '@/styled-system/css';

export const menuItemIconRecipe = cva({
  base: {
    gridArea: 'icon',
    width: 'icon.md',
    height: 'icon.md',
  },
  variants: {
    anchor: {
      true: {
        color: {
          base: 'icon.action.neutral.default',
        },
      },
      false: {
        color: {
          base: 'icon.action.neutral.default',
        },
      },
    },
    disabled: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      anchor: true,
      disabled: false,
      css: {
        color: {
          _groupHover: 'icon.link.hover',
          _groupActive: 'icon.action.neutral.pressed',
        },
      },
    },
    {
      anchor: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'icon.action.neutral.hover',
          _groupActive: 'icon.action.neutral.pressed',
        },
      },
    },
  ],
});
